export const getDayIndex = (dayString) => {
    let dayStrings = ['sun','mon','tue','wed','thu','fri','sat']
    return dayStrings.indexOf(dayString)
}

export const getDayString = (index) => {
    let dayStrings = ['sun','mon','tue','wed','thu','fri','sat']
    return dayStrings[index]
}

export const getCurrentTime = () => {
    let date = new Date()
    let result = 
        {
            day: date.getUTCDay(),
            hour: date.getUTCHours(),
            minute: date.getUTCMinutes(),
            second: date.getUTCSeconds(),
        }
}

export function getTimeUntil(time){
    const total = Date.parse(time) - Date.parse(new Date());
    const seconds = Math.floor( (total/1000) % 60 );
    const minutes = Math.floor( (total/1000/60) % 60 );
    const hours = Math.floor( (total/(1000*60*60)) % 24 );
    const days = Math.floor( total/(1000*60*60*24) );
  
    return {
      total,
      days,
      hours,
      minutes,
      seconds
    };
}

export function getTimeSince(time){
    const total = Date.parse(new Date()) - Date.parse(time);
    const seconds = Math.floor( (total/1000) % 60 );
    const minutes = Math.floor( (total/1000/60) % 60 );
    const hours = Math.floor( (total/(1000*60*60)) % 24 );
    const days = Math.floor( total/(1000*60*60*24) );
  
    return {
      total,
      days,
      hours,
      minutes,
      seconds
    };
}